<template>
  <div class="client" :class="{ print: printing }">
    <dg-header v-if="loaded && !printing"></dg-header>
    <dg-print-header v-if="printing"></dg-print-header>
    <dg-calculator
      :printing="printing"
      :companies="companies"
      :chosenCompanies="chosenCompanies"
      :type="type"
      v-if="loaded"
      v-on:updatePrice="updatePrice"
      v-on:updateType="updateType"
      v-on:handleCompany="handleCompany"
      v-on:updateDiscount="updateDiscount"
      v-on:handleOnlyThisCompany="handleOnlyThisCompany"
    ></dg-calculator>
    <dg-result
      :companies="companies"
      :chosen="chosenCompanies"
      :type="type"
      v-if="loaded && !printing"
    ></dg-result>
    <dg-savings
      v-if="loaded"
      :printing="printing"
      :companies="selectedCompanies"
      :type="type"
      v-on:sendToPrinting="sendToPrinting"
      :savings="savings"
      v-on:updateSavings="updateSavings"
    ></dg-savings>
  </div>
</template>

<script>
  // Libraries
  import axios from 'axios'

  // Components
  import dgHeader from 'components/views/header.vue'
  import dgCalculator from 'components/views/calculator.vue'
  import dgResult from 'components/views/result.vue'
  import dgSavings from 'components/views/savings.vue'
  import dgPrintHeader from 'components/views/printHeader.vue'

  export default {
    data () {
      return {
        printing: false,
        loaded: false, // Data must be fetched for rendering dependent components
        type: 'gasPrice', // Type gas/diesel
        chosenCompanies: [
          'Tanka'
        ],
        companies: [
          {
            website: 'http://www.tanka.se/',
            logotype: require('assets/images/logos/tankaLarge.png'),
            name: 'Tanka',
            data: {}
          },
          {
            website: 'https://www.okq8.se/foretag/priser/#/',
            logotype: require('assets/images/logos/okq8Large.png'),
            name: 'OKQ8',
            data: {}
          },
          /*
          {
            website: 'https://',
            logotype: require('assets/images/logos/shell.png'),
            name: 'Shell',
            data: {}
          },
          */
          {
            website: 'https://www.circlek.se/foretag/drivmedel/drivmedelspriser',
            logotype: require('assets/images/logos/circlekLarge.png'),
            name: 'Circle K',
            data: {}
          },
          {
            website: 'https://www.preem.se/foretag/kund-hos-preem/listpriser/listpriser-foretagskort/',
            logotype: require('assets/images/logos/preemLarge.png'),
            name: 'Preem',
            data: {}
          },
          {
            logotype: require('assets/images/logos/other.png'),
            name: 'Other',
            data: {
              gasPrice: 0,
              dieselPrice: 0,
              gasPriceList: 0,
              dieselPriceList: 0,
              invoiceDiscount: 0,
              cardDiscount: 0
            }
          }
        ],
        savings: {
          mileage: 2500,
          cars: 1,
          price: 0
        }
      }
    },
    mounted () {
      const that = this

      // Get API data and insert data to every company
      axios.get('https://volvofinans.fbinhouse.se/vfin-drivmedelsguiden-api-q2-2017/api').then((response) => {
        response.data.forEach((x) => {
          that.companies.forEach((y, i) => {
            if (y.name === x['namn']) {
              // Use Vue $set method to make new object properties reactive
              that.$set(that.companies[i].data, 'gasPrice', parseFloat(x['bensin_pris'].replace(',', '.')))
              that.$set(that.companies[i].data, 'dieselPrice', parseFloat(x['diesel_pris'].replace(',', '.')))
              that.$set(that.companies[i].data, 'gasPriceList', parseFloat(x['bensin_pris_list'].replace(',', '.')))
              that.$set(that.companies[i].data, 'dieselPriceList', parseFloat(x['diesel_pris_list'].replace(',', '.')))
              that.$set(that.companies[i].data, 'invoiceDiscount', -window.Math.abs(parseInt(x['faktura_rabatt']) / 100))
              that.$set(that.companies[i].data, 'cardDiscount', -window.Math.abs(parseInt(x['kort_rabatt']) / 100))
            }
            // When loaded, tell child components to render
            that.loaded = true
          })
        })

        const urls = this.getUrlVars()
        if (urls.print) {
          const data = JSON.parse(window.decodeURIComponent(urls.data))
          this.printing = true
          if (data.type) {
            this.type = data.type
          }
          if (data.chosenCompanies) {
            this.chosenCompanies = data.chosenCompanies
          }
          if (data.companies) {
            this.companies = data.companies
          }
          if (data.savings) {
            this.savings = data.savings
          }
        }
      }).catch((response) => {
        console.warn('Could not fetch data, is API running?\n', response)
      })

      if (window.innerWidth < 800 && this.chosenCompanies.length <= 1) {
        this.chosenCompanies.push(this.companies[1].name)
      }

      window.addEventListener('resize', (e) => {
        if (e.target.innerWidth < 800 && this.chosenCompanies.length <= 1) {
          this.chosenCompanies.push(this.companies[1].name)
        }
      }, false)
    },
    methods: {
      getUrlVars () {
        let hash
        const myJson = {}
        const hashes = window.location.search.slice(window.location.search.indexOf('?') + 1).split('&')
        for (let i = 0; i < hashes.length; i++) {
          hash = hashes[i].split('=')
          myJson[hash[0]] = hash[1]
        }
        return myJson
      },
      updateSavings (obj) {
        this.savings[obj.name] = obj.value
      },
      sendToPrinting () {
        const data = {}
        data.type = this.type
        data.chosenCompanies = this.chosenCompanies
        data.companies = this.companies
        data.savings = this.savings
        // const string = window.location.toString() + '?print=true&data=' + window.encodeURIComponent(JSON.stringify(data))
        // window.location.href = string
        window.open('http://pdf.fbinhouse.se/generate?url=' + window.encodeURIComponent(window.location.toString() + '?print=true&data=' + window.encodeURIComponent(JSON.stringify(data))), '_blank')
      },
      updatePrice (event, company, type) {
        const that = this
        this.companies.forEach((x, i) => {
          if (x.name === company) {
            that.$set(that.companies[i].data, type, parseFloat(event.target.value))
          }
        })
      },
      updateType (value) {
        this.type = value
      },
      updateDiscount (value, type, company) {
        const that = this
        let val = parseFloat((parseInt(value) / 100))
        if (!val) {
          val = 0
        }
        this.companies.forEach((x, i) => {
          if (x.name === company) {
            that.$set(that.companies[i].data, type, val)
          }
        })
      },
      handleCompany (value) {
        if (this.chosenCompanies.includes(value)) {
          this.chosenCompanies = [
            ...this.chosenCompanies.slice(0, this.chosenCompanies.indexOf(value)),
            ...this.chosenCompanies.slice(this.chosenCompanies.indexOf(value) + 1)
          ]
          return
        }

        this.chosenCompanies.push(value)
      },
      handleOnlyThisCompany (value) {
        this.chosenCompanies = [
          'Tanka',
          value
        ]
      }
    },
    computed: {
      selectedCompanies () {
        const that = this
        return that.companies.filter((x) => {
          return that.chosenCompanies.includes(x.name)
        })
      }
    },
    components: {
      dgHeader,
      dgCalculator,
      dgResult,
      dgSavings,
      dgPrintHeader
    }
  }
</script>

<style rel="stylesheet/scss" type="text/css" lang="scss">
  @import "~styles/fonts.scss";

  // Global Css elements
  * {
    padding: 0;
    margin: 0;
  }

  html, body, .client {
    min-height: 100%;
    height: 100%;
    overflow: visible;
    font-family: 'Volvo Sans Regular', sans-serif;
    text-align: center;
    background: #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// app.vue?e98c3666